import { useSessionState } from '@/components/providers/SessionBoundary';

export function useAuth() {
  const { session, isAuthenticated, isLoading } = useSessionState();
  const user = session?.user ?? undefined;

  return {
    isAuthenticated,
    isLoading,
    user,
    session,
  };
}
